export default __webpack_public_path__ + "static/pipedrive-4c55c068a0692cebaa26a090cf5cf53b.png";